import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Name = ({
  nameList,
  setUserSelection,
  selectedItems,
  title,
  rarityList,
  data
}) => {
  const [isListOpen, setList] = useState(false);
  const [name, setName] = useState(
    selectedItems.name ? selectedItems.name.approved_name : "Pick a name"
  );
  
  const toggleList = () => {
    setList(!isListOpen);
  };

  const changeName = (item) => {
    setUserSelection({ name: { ...item, category: "approvedname" } });
    setName(item.approved_name);
  };

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      // Function for click event
      function handleOutsideClick(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setList(false);
        }
      }

      // Adding click event listener
      document.addEventListener("click", handleOutsideClick);
      return () => document.removeEventListener("click", handleOutsideClick);
    }, [ref]);
  };

  const box = useRef(null);
  useOutsideAlerter(box);

  return (
    <>
      <h3 className="mint__step-title">{title}</h3>
      <div
        className="nft-name__dropdown-wrapper"
        onClick={toggleList}
        ref={box}
      >
        <div
          className="nft-name__dropdown-top"
        >
          <div className="nft-name__dropdown-header">
            <span className="nft-name">
              {name}
            </span>
          </div>
          <div className="chevron-down">
            <FontAwesomeIcon icon="fa-solid fa-chevron-down" color={data.web_main_color} size='xl' />
          </div>
        </div>
        <div
          className={`nft-name__dropdown-bottom ${
            isListOpen ? "d-block" : "d-none"
          }`}
        >
          <ul className="nft-name__lists">
            {nameList.map((item, index) => (
              <li
                key={index}
                className="nft-name__list"
                onClick={() => changeName(item)}
                style={{color: data.web_main_color, "--dropdown-hover-color": data.secondary_color}}
              >
                {item.approved_name}
              </li>
            ))}
          </ul>
        </div>
      </div>      
    </>
  );
};

export default Name;
